<div class="flip-card-inner">
  <ng-content select="[luiFlipCardFront]"></ng-content>
  <ng-content select="[luiFlipCardBack]"></ng-content>
</div>
